module.exports = __webpack_public_path__ + "static/foundation-f277fb13561c23d8cf6b8079c0a7489d.png";